<template>
  <Suspense>
    <template #default>
      <App />
    </template>
    <template #fallback>
      <loading-full></loading-full>
    </template>
  </Suspense>
</template>

<script>
import App from './App.vue'
import LoadingFull from './components/include/LoadingFull.vue'

export default {
  name: 'SuspenserComponent',
  components: {
    App,
    LoadingFull
  }
}
</script>
